import { useState } from "react";
import { toast } from "react-toastify";
   import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
import { useRef } from "react";
import { useForm, Controller } from "react-hook-form";
gsap.registerPlugin(ScrollTrigger, SplitText);
/**
 * @module Section-Contact-Form
 */

/**
 *
 * @returns Markup for sample contact form
 */
const apiData =
  "https://script.google.com/macros/s/AKfycby7_aCV7oQaceAHDjpG045SN0DnRHHNRzYi9MRkQ7Y3L04TC7S473T3z5F9bEd9x1IKZQ/exec";

const SectionContactForm = () => {
  const [phone, setPhone] = useState("");
  const [successm, setSuccessm] = useState(false);
  const [message, setMessage] = useState({
    type: "success",
    info: "Form submission failed. Please try again.",
  });
  const [btnDisabled, setBtnDisabled] = useState(false);
  const {
    register,
    control,
    handleSubmit,
    trigger,
    formState: { errors, isValid, isSubmitted },
    watch,
  } = useForm({
    mode: "onBlur",
  });
  const formHandlerSubmit = async (e: any) => {
    e.preventDefault();
    const valid = await trigger();
    if (!valid) {
      setBtnDisabled(false);
      return;
    }
    setBtnDisabled(true);

    const f = e.target;
    const data = new FormData(f);
    const formData = Object.fromEntries(data);
    const createdby = new Date();
    const options: any = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const formattedDate = createdby.toLocaleString("en-US", options);
    formData.CreatedDate = formattedDate;

    try {
      const response = await fetch(apiData, {
        method: "POST",
        body: JSON.stringify(formData),
      });

      f.reset();
      setPhone("");
      if (response.ok) {
        toast.success("Form submitted successfully!");
      } else {
        toast.error("Submission failed. Try again.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }

    setSuccessm(true);

    setTimeout(() => {
      setSuccessm(false);
      setBtnDisabled(false);
    }, 3000);
  };
   const container = useRef<HTMLDivElement | null>(null);

  useGSAP(
    () => {
    //   let split = SplitText.create(".about_para_animation", {
    //     type: "lines",
    //   });
 
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top+=250 bottom",
          end: "bottom",
        //   markers: true
        },
      });
    //   tl.fromTo(
    //     ".reveal",
    //     { scale: 0.8, opacity: 0 },
    //     { scale: 1, duration: 1, opacity: 1 },
    //   )

tl.fromTo(
          ".contact_heading_animation",
          { opacity: 0, y: 60 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
          }, "0"
        )
        .fromTo(
          ".contact_field_animation",
          { opacity: 0, y: 40 },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            stagger: 0.1,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, "0.4"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
  return (
    
    <div className="cons-contact-form-wrap">
      <div className="comments-area" ref={container}>
        <h3 className="av-large-title mb-4 contact_heading_animation">Contact Us</h3>
        <form
          className="comment-form cons-contact-form"
          method="post"
          onSubmit={formHandlerSubmit}
        >
          <div className="row">
            <div className="comment-form-author col-md-6 mb-3 contact_field_animation">
              <label>
                <span className={`${errors.FullName ? "error_message" :""}`}>Your Name</span>
              </label>
              <input
                type="text"
                id="FullName"

                placeholder="Your Name*"
                className={`form-control ${errors.FullName ? "form_err_field" : ""}`}
                {...register("FullName", {
                  required: "Name is required",
                  minLength: {
                    value: 2,
                    message: "Name must be at least 2 characters",
                  },
                })}
              />
              {errors.FullName && (
                <p className="error_message">
                  &nbsp;{errors.FullName.message as string}
                </p>
              )}
            </div>
            <div className="comment-form-email col-md-6 mb-3 contact_field_animation">
              <label>
                <span className={`${errors.Email ? "error_message" :""}`}>Your Email</span>
              </label>
              <input
                type="text"
                id="Email"
                placeholder="Your Email*"
                className={` form-control ${errors.Email ? "form_err_field" :""}`}
               {...register("Email", {
                              required: "Email is required",
                              pattern: {
                                value:
                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                message: "Please enter a valid email address",
                              },
                            })}
                          />  {errors.Email && (
                          <p className="error_message">
                            &nbsp;{errors.Email.message as string}
                          </p>
                        )}
              
            </div>
            <div className="comment-form-comment col-md-12 mb-4 contact_field_animation">
              <label >
                <span className={`${errors.Message ? "error_message" :""}`}>Message</span>
              </label>
              <textarea
            
                rows={8}
                placeholder="Message*"
                id="Message"
                className={`form-control ${errors.Message ? "form_err_field" :""}`}
              {...register("Message", {
                              required: "This field is required",
                            })}
                          />{errors.Message && (
                          <p className="error_message">
                            &nbsp;{errors.Message.message as string}
                          </p>
                        )}
            </div>
            <div className="comment-form-cookies-consent mb-4 contact_field_animation">
              {/*    <p>
                                <span>*</span> Call us 24/7  or fill out the form below to receive a free.
                            </p> */}
            </div>
            <div className="form-submit contact_field_animation">
              <button type="submit" className="site-button">
                {btnDisabled ? "Processing..." : "Submit"}
                {/* <i className="fa fa-plus" /> */}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SectionContactForm;
